/*
(V.O.) - This stands for "voiceover" and indicates that the character is speaking off-screen, either as a narrator or as a character who is not currently visible on screen.
(O.S.) - This stands for "off-screen" and indicates that the character is speaking from a location that is not currently visible on screen.
(CONT'D) or (CONTINUOUS) - This indicates that the character's dialogue is continuing from the previous line of dialogue, which may have been interrupted by another character's dialogue or an action description.
(INTO PHONE) or (INTO INTERCOM) - These annotations indicate that the character is speaking into a phone or an intercom system, which can affect the way their dialogue is delivered.
(WHISPERING) or (YELLING) - These annotations indicate that the character is speaking in a certain tone or volume, which can also affect the way their dialogue is delivered.
(SUBTITLE) - This annotation is used when a character is speaking in a language that is not understood by the audience, and their dialogue is translated into subtitles on screen. */

// @todo: clean up this refactor remove duplication
const CHARACTERS_SPECIFIC = [
  '(V.O.)',
  '(V.O)',
  '(O.S.)',
  '(O.S)',
  '(CONT\'D)',
  '(CONT’D)',
  '(COND&#39;T)',
  '(COND&#39;D)',
  '(CONT&#39;D)',
  '(INTO PHONE)',
  '(INTO INTERCOM)',
  '(WHISPERING)',
  '(YELLING)',
  '(SUBTITLE)',
  '(ON RADIO)',
  '(WOMANV.O.)',
  '(WOMAN V.O.)',
  '(MANV.O.)',
  '(MAN V.O.)',
  '(O.C.)',
  '(O.C)'
]

const TRANSITIONS = [
  'CUT TO:',
  'BACK TO:',
  'FADE IN:',
  'FADE OUT.',
  'FADE TO:',
  'FADE TO BLACK.',
  'JUMP CUT TO:',
  '(PRE-LAP)',
  'CONTINUED',
  '(CONTINUED)',
  'FADE IN',
  'FADE OUT',
  'DISSOLVE TO:',
  'SMASH CUT TO:',
  'CUT TO BLACK.',
  'RAPID CUT TO:',
  'TITLE CARD',
  'FINAL SHOOTING SCRIPT',
  'CUT TO BLACK', 'CUT TO:',
  'SUBTITLE:',
  'SMASH TO:',
  'BACK TO:',
  'FADE OUT:',
  'END',
  'CUT BACK:',
  'CUT BACK',
  'DISSOLVE TO:',
  'CONTINUED',
  'RAPID CUT',
  'RAPID CUT TO', '' +
  'FADE TO:',
  'FADE IN:', 'FADE OUT:',
  'FADES TO BLACK',
  'FADE TO',
  'CUT TO',
  'FADE TO BLACK',
  'FADE UP:',
  'BEAT',
  'CONTINUED:',
  'FADE IN',
  'TO:',
  'CLOSE-UP',
  'WIDE ANGLE',
  'WIDE ON LANDING',
  'THE END',
  'FADE OUT',
  'CONTINUED:',
  'TITLE:',
  'FADE IN',
  'DISSOLVE TO',
  'CUT-TO',
  'CUT TO',
  'CUT TO BLACK',
  'INTERCUT',
  'INSERT',
  'CLOSE UP',
  'CLOSE',
  'ON THE ROOF',
  'BLACK',
  'BACK IN SILENCE',
  'TIMECUT',
  'BACK TO SCENE',
  'REVISED',
  'PERIOD', 'PROLOGUE',
  'TITLE',
  'SPLITSCREEN.',
  'BLACK.',
  'FADE OUT', 'CUT HARD TO:',
  'OMITTED',
  'DISSOLVE',
  'WIDE SHOT',
  'NEW ANGLE',
  'DAYLIGHT',
  'BLACK',
  'WHITE'
]

const SCENE_HEADING_SPECIFIC = [
  'DAYLIGHT',
  'BLACK',
  'WHITE'
]

const DEFAULT_AI_USER = {
  id: 'nolan',
  displayName: 'Nolan'
}

const EXCLUDE_FROM_TEXT_CONVERSION = ['sceneImage', 'sceneImageRenderer', 'sceneVideo', 'sceneVideoRenderer']

const EXCLUDE_CHARACTER_DEFINITION = ['white', 'black']

const SCENE_HEADING_DAY_TERMS = ['DAY', 'NIGHT', 'EARLY MORNING', 'DAWN', 'DUSK']

export {
  CHARACTERS_SPECIFIC,
  TRANSITIONS,
  DEFAULT_AI_USER,
  EXCLUDE_FROM_TEXT_CONVERSION,
  EXCLUDE_CHARACTER_DEFINITION,
  SCENE_HEADING_SPECIFIC,
  SCENE_HEADING_DAY_TERMS
}
